/*eslint-disable */

import {
  mapGetters,
  mapState
} from 'vuex';

import {
  bus
} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'user-verify',
  components: {},
  props: [],
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'getUserVerifiedState'
    ]),
    UserVerfiedFun() {
      this.$store.dispatch('getUserVerifiedFun', {
          id: this.$route.params.id
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.$router.push('/login/')
        }).catch((err) => {
          toast.error("Your Account is not verified...");
          this.$router.push('/login/')
        })
    }
  },
  mounted() {
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    this.UserVerfiedFun
  },
  methods: {}
}